import React from 'react';
import styled from 'styled-components';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { AnimatedSection } from '../common/AnimatedSection';
import ProductGrid from './ProductGrid';
import { useNavigate } from 'react-router-dom';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #ffffff;
  padding-top: 10%;

  @media (max-width: 768px) {
    padding-top: 30%;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 3rem;

  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
  padding: 3rem 0;
`;

const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #111111;
  margin-bottom: 1.5rem;
  letter-spacing: -1px;
`;

const PageSubtitle = styled.p`
  font-size: 1.1rem;
  color: #6b7280;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    white-space: pre-line; 
  }
`;

function ProductCategoryPage({ title, subtitle, products }) {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [gridRef, gridVisible] = useScrollAnimation();
  const navigate = useNavigate();

  const handleClick = (product) => {
    if (product.detailPath) navigate(product.detailPath);
  };

  return (
    <PageContainer>
      <Container>
        {/* <AnimatedSection ref={headerRef} isVisible={headerVisible} animation="fadeInUp"> */}
        <PageHeader>
          <PageTitle>{title}</PageTitle>
          <PageSubtitle>{subtitle}</PageSubtitle>
        </PageHeader>
        {/* </AnimatedSection> */}

        {/* <AnimatedSection ref={gridRef} isVisible={gridVisible} animation="fadeInUp" delay="0.2s"> */}
        <ProductGrid products={products} onItemClick={handleClick} />
        {/* </AnimatedSection> */}
      </Container>
    </PageContainer>
  );
}

export default ProductCategoryPage;
